import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'timeFromNow',
  pure: false
})
export class TimeFromNowPipe implements PipeTransform, OnDestroy {
  private timestamp = moment();
  private timestampInterval;

  constructor() {
    this.timestampInterval = setInterval(() => {
      this.timestamp = moment();
    }, 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.timestampInterval);
  }

  transform(dateTime: moment.MomentInput): string {
    return moment.utc(this.timestamp.diff(moment(dateTime))).format('HH:mm:ss');
  }
}
